import _sfc_main from './src/input-number.vue2.mjs';
export { inputNumberEmits, inputNumberProps } from './src/input-number.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElInputNumber = withInstall(_sfc_main);

export { ElInputNumber, ElInputNumber as default };
//# sourceMappingURL=index.mjs.map
